import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR';

export const ADD_CATEGORY_REQUEST = 'ADD_CATEGORY_REQUEST';
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_ERROR = 'ADD_CATEGORY_ERROR';

export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_ERROR = 'DELETE_CATEGORY_ERROR';


export const getCategories = () => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: GET_CATEGORIES_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/category`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: GET_CATEGORIES_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: GET_CATEGORIES_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}

// data: { id (when editing), name, status }
export const addCategory = (data, edit) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: ADD_CATEGORY_REQUEST
            })
            axios({
                method: edit ? 'PUT' : 'POST',
                url: edit ? `${SERVER_URL}v1/category/${data.id}` : `${SERVER_URL}v1/category`,
                headers: headers,
                data: { name: data.name, status: data.status },
            }).then(function (response) {
                dispatch({
                    type: ADD_CATEGORY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: ADD_CATEGORY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}

export const deleteCategory = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: DELETE_CATEGORY_REQUEST
            })
            axios({
                method: 'DELETE',
                url: `${SERVER_URL}v1/category/${id}`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: DELETE_CATEGORY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: DELETE_CATEGORY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
